import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchPosts } from './postsAPI';

const initialState = {
    posts: [],
    loading: false,
    errorMessage: '',
    isError: '',
};

export const getPosts = createAsyncThunk(
    'posts/fetchPosts',
    async (filter) => {
        const data = await fetchPosts(filter);
        return data;
    }
);

export const postSlice = createSlice({
    name: 'post',
    initialState,

    // The `extraReducers` field lets the slice handle actions defined elsewhere,
    // including actions generated by createAsyncThunk or in other slices.
    extraReducers: (builder) => {
        builder
            .addCase(getPosts.pending, (state) => {
                state.loading = true;
                state.errorMessage = '';
                state.isError = false;
                state.posts = [];

            })
            .addCase(getPosts.fulfilled, (state, action) => {
                state.loading = false;
                state.errorMessage = '';
                state.isError = false;
                state.posts = action.payload;
            })
            .addCase(getPosts.rejected, (state, action) => {
                state.loading = false;
                state.errorMessage = action.error;
                state.isError = true;
                state.posts = [];
            })
    },
});


export default postSlice.reducer;
